import { Avatar, AvatarBadge, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { AnimatePresence } from 'framer-motion'
import * as React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useAppContext } from '../../../../context/AppProvider'
import { useAuthContext } from '../../../../context/AuthProvider'
import { MenuItem, Tooltip } from './styles'
import { useHistory } from 'react-router-dom'

export const MenuUserProfile = () => {
  const { user } = useAuthContext()
  const { drawerOpen } = useAppContext()
  const history = useHistory()
  const { isLive } = useAppContext()
  const fullName = `${user?.attributes?.firstName} ${user?.attributes?.lastName}`
  return (
    <Flex
      align="center"
      justify={!drawerOpen ? 'center' : undefined}
      width="100%"
      shadow={!drawerOpen ? 'md' : undefined}
      bg="transparent"
      onClick={() => history.push('/auth/settings')}
      cursor="pointer"
    >
      <Avatar
        src={user?.attributes?.profilePicture?.data?.attributes?.url}
        size="sm"
        name={fullName}
        mr={1}
      >
        <AvatarBadge boxSize=".8rem" bg={isLive ? 'gray.600' : 'red.300'} />
      </Avatar>

      {drawerOpen && (
        <VStack width="100%" spacing={0} alignItems="flex-start" ml={2}>
          <Heading wordBreak="break-all" fontWeight="500" noOfLines={1} as="h4" fontSize="sm">
            {fullName}
          </Heading>
          <Text color="gray.600" wordBreak="break-all" noOfLines={1} fontSize="x-small">
            {user?.attributes?.email}
          </Text>
        </VStack>
      )}
    </Flex>
  )
}

type SideBarItemProps = {
  title: string
  to: string
  color: string
  hoverColor: string
  accentColor: string
  icon: React.ReactNode
  tooltipColor?: string
  tooltipBg?: string
  className?: string
}

const SideBarItem: React.FC<SideBarItemProps> = ({
  accentColor,
  color,
  hoverColor,
  icon,
  title,
  to,
  tooltipColor,
  tooltipBg,
  className
}) => {
  const { drawerOpen } = useAppContext()

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 48em)' })

  return (
    <MenuItem
      to={to}
      color={color}
      bg={accentColor}
      hovercolor={hoverColor}
      accentcolor={accentColor}
      width={drawerOpen ? 'calc(100% - 24px)' : '56px'}
      activeClassName="active-nav-link"
    >
      <Flex
        height="44px"
        alignItems="center"
        justifyContent={drawerOpen ? 'flex-start' : 'center'}
        w="100%"
        minW={0}
        px={drawerOpen ? 4 : 0}
        py={0}
        className="sidebar-nav-item-wrapper"
      >
        <HStack spacing={3} w="100%" minW={0} justify={drawerOpen ? 'flex-start' : 'center'}>
          <Flex
            className={`icon-wrap ${className || ''}`}
            boxSize={5}
            align="center"
            justify="center"
            flexShrink={0}
          >
            {icon}
          </Flex>
          <AnimatePresence>
            {drawerOpen && (
              <Text
                color={color}
                fontWeight="600"
                fontSize="xs"
                lineHeight="1.3"
                noOfLines={1}
                minW={0}
                flex={1}
              >
                {title}
              </Text>
            )}
          </AnimatePresence>
        </HStack>
        {!drawerOpen && !isTabletOrMobile && (
          <Tooltip bg={tooltipBg || 'gray.800'} className="sidebar-tooltip">
            <Text fontSize={13} fontWeight="semibold" color={tooltipColor || 'white'}>
              {title}
            </Text>
          </Tooltip>
        )}
      </Flex>
    </MenuItem>
  )
}

export default SideBarItem
